import humps from 'lodash-humps-ts';
import { authAxios } from '@components/Auth';
import { InsurerTeam } from '@models/InsurerTeam';
import { API_V1_BASE } from '@config';

export class InsurerTeamApi {
  static getAll = async () => {
    return await authAxios
      .get(`${API_V1_BASE}/insurer_teams`)
      .then((response) => humps(response.data) as InsurerTeam[]);
  };
}
